import {
  centerTypeColors,
  centerTypeLabels,
  type CenterType
} from '../../constants/centerTypes'

interface CenterTypeBadgeProps {
  centerType: CenterType
  size?: 'sm' | 'md'
}

export default function CenterTypeBadge({
  centerType,
  size = 'md'
}: CenterTypeBadgeProps) {
  const sizeClasses =
    size === 'sm' ? 'px-3 py-1 text-xs' : 'px-4 py-1.5 text-sm'

  return (
    <span
      className={`inline-block rounded font-semibold tracking-wider ${sizeClasses} ${centerTypeColors[centerType]}`}
    >
      {centerTypeLabels[centerType]}
    </span>
  )
}
